import createLucideIcon from '../createLucideIcon';

const ChevronsLeft = createLucideIcon('ChevronsLeftIcon', [
  ['path', { d: 'm11 17-5-5 5-5', key: '13zhaf' }],
  ['path', { d: 'm18 17-5-5 5-5', key: 'h8a8et' }],
]);

export default ChevronsLeft;
